import React from 'react'
import useExecuteTx, {
  UseExecuteTxProps,
} from 'src/common/contracts/hooks/useExecuteTx'
import SmartButton, { SmartButtonProps } from './SmartButton'

type TransactionButtonProps = SmartButtonProps & UseExecuteTxProps

const TransactionButton: React.FC<TransactionButtonProps> = ({
  transaction,
  loading: loadingProp,
  disabled,
  children,
  onSuccess,
  onError,
  ...rest
}) => {
  const { executeTx, isPending: txPending } = useExecuteTx({
    onSuccess,
    onError,
    transaction,
  })

  const loading = txPending || loadingProp

  return (
    <SmartButton
      disabled={loading || disabled}
      loading={loading}
      onClick={executeTx}
      {...rest}
    >
      {children}
    </SmartButton>
  )
}

export default TransactionButton
